var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dma-table"},[_c('sz-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"columns":_vm.columns,"table-data":_vm.tableData,"row-style":{ height: '60px' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }